import { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { Grid, Label } from '@wf/sw-ui-kit';

import CountryOfExportOrImport from '../CountryOfExportOrImport';
import AdditionalFields from '../AdditionalFields';
import { LicenseField } from '../LicenseField';

import { ConsignmentTabFields } from '../../types/fieldEnums';
import { FieldPrefix } from '../../constants/fieldPrefixes';
import { Tab } from '../../types/enums';

import { RimmEntityType } from '../../../rimm/data/rimmEntityEnums';

import styles from './Consignment.module.scss';

function Consignment() {
  const { t } = useTranslation();

  return (
    <>
      <Grid columns="repeat(3, minmax(0, 1fr))">
        <CountryOfExportOrImport />
        <LicenseField.RimmSelectField
          label={
            <Label
              helpText={t('Country through which the consignment will transit before reaching its final destination')}
            >
              {t('Transit Country')}
            </Label>
          }
          configName={ConsignmentTabFields.transitCountryCode}
          name={ConsignmentTabFields.transitCountryCode}
          entity={RimmEntityType.country}
          placeholder={t('Select...')}
          withTag
        />
        <LicenseField.TextField
          label={
            <Label helpText={t('Location where the consignment will first arrive after leaving the country of export')}>
              {t('First Point Of Arrival')}
            </Label>
          }
          configName={ConsignmentTabFields.firstPointOfArrival}
          name={ConsignmentTabFields.firstPointOfArrival}
          placeholder={t('First Point Of Arrival')}
          className={styles.firstColumn}
        />
        <LicenseField.RimmSelectField
          label={
            <Label helpText={t('Type of transportation used for shipping the consignment')}>
              {t('Mean Of Transport')}
            </Label>
          }
          configName={ConsignmentTabFields.meanOfTransportCode}
          name={ConsignmentTabFields.meanOfTransportCode}
          entity={RimmEntityType.modeOfTransport}
          placeholder={t('Select...')}
          withTag
        />
        <LicenseField.TextField
          label={
            <Label helpText={t('Identifying details of the transport used')}>{t('Transport Means Of Identity')}</Label>
          }
          configName={ConsignmentTabFields.transportMeansOfIdentity}
          name={ConsignmentTabFields.transportMeansOfIdentity}
          placeholder={t('Transport Means Of Identity')}
          className={styles.firstColumn}
        />
        <LicenseField.TextField
          label={
            <Label helpText={t('Unique voyage number or transport reference number for tracking the consignment')}>
              {t('Voyage Number')}
            </Label>
          }
          configName={ConsignmentTabFields.voyageNumber}
          name={ConsignmentTabFields.voyageNumber}
          placeholder={t('Voyage Number')}
        />
      </Grid>
      <AdditionalFields tab={Tab.CONSIGNMENT} configNamePrefix={FieldPrefix.lpco} />
    </>
  );
}

export default memo(Consignment);
